export const shortjoin = (arr: any[], max: number) => {
  return arr
    .slice(0, max)
    .join(', ')
    .concat(arr.length > max ? ` +${arr.slice(max).length}` : '')
}
